(function(){
  'use strict';
  var root=document.querySelector('[data-emx-pulse]');
  if(!root)return;
  var form=root.querySelector('[data-emx-quickfinder]');
  if(!form||form.dataset.quickfinderReady==='true')return;
  form.dataset.quickfinderReady='true';

  var brand=form.querySelector('[data-emx-brand]');
  var model=form.querySelector('[data-emx-model]');
  var part=form.querySelector('[data-emx-part]');
  var submit=form.querySelector('[data-emx-submit]');
  var submitLabel=form.querySelector('[data-emx-submit-label]');
  var status=form.querySelector('[data-emx-selector-status]');
  var fields=Array.prototype.slice.call(form.querySelectorAll('.emx-quickfinder__field'));
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var firstReadyShown=false;

  var models={
    talaria:[
      {label:'Sting TL-3000',handle:'pieces-talaria-sting-tl-3000'},
      {label:'Sting TL-4000',handle:'pieces-talaria-sting-tl-4000'},
      {label:'Sting Pro TL-5500',handle:'pieces-talaria-sting-pro-tl-5500'},
      {label:'XXX',handle:'pieces-talaria-xxx-selecteur'},
      {label:'Komodo',handle:'pieces-talaria-komodo'}
    ],
    surron:[
      {label:'Light Bee',handle:'pieces-surron-light-bee'},
      {label:'Ultra Bee',handle:'pieces-surron-ultra-bee'},
      {label:'Storm Bee',handle:'pieces-surron-storm-bee'}
    ],
    stark:[
      {label:'VARG MX',handle:'pieces-stark-varg-mx'},
      {label:'VARG EX',handle:'pieces-stark-varg-ex'},
      {label:'VARG SM',handle:'pieces-stark-varg-sm'}
    ],
    sedna:[
      {label:'MX12',handle:'pieces-sedna-mx12'},
      {label:'MX16',handle:'pieces-sedna-mx16'},
      {label:'SX16',handle:'pieces-sedna-sx16'},
      {label:'SX18',handle:'pieces-sedna-sx18'},
      {label:'SX20',handle:'pieces-sedna-sx20'}
    ]
  };

  function setProgress(value){form.style.setProperty('--emx-selector-progress',value+'%');}
  function setField(index,active){if(fields[index])fields[index].classList.toggle('is-active',!!active);}
  function activateField(index){
    setField(index,true);
    if(!fields[index]||reduce)return;
    fields[index].classList.add('is-just-activated');
    window.setTimeout(function(){fields[index].classList.remove('is-just-activated');},360);
  }
  function track(name,data){
    if(typeof window.emxTrack==='function')window.emxTrack(name,data||{});
  }

  function clearModels(){
    model.innerHTML='<option value="">Choisir un modèle</option>';
    model.disabled=true;
    part.disabled=true;
    part.value='all';
    submit.disabled=true;
    form.classList.remove('is-armed','is-confirmed');
    setField(1,false);setField(2,false);
    if(submitLabel)submitLabel.textContent='Afficher les pièces compatibles';
  }

  function populateModels(key){
    clearModels();
    if(!key){setProgress(0);status.textContent='Sélectionnez votre moto pour commencer.';return;}
    (models[key]||[]).forEach(function(item){
      var option=document.createElement('option');option.value=item.handle;option.textContent=item.label;model.appendChild(option);
    });
    model.disabled=false;activateField(1);setProgress(34);status.textContent='Choisissez maintenant votre modèle.';
  }

  brand.addEventListener('change',function(){track('emx_selector_brand',{brand:brand.value||'none'});populateModels(brand.value);});

  model.addEventListener('change',function(){
    var ready=!!model.value;part.disabled=!ready;submit.disabled=!ready;setField(2,false);form.classList.toggle('is-armed',ready);form.classList.remove('is-confirmed');
    track('emx_selector_model',{brand:brand.value||'',model:model.value||'none'});
    if(ready){
      activateField(2);setProgress(72);status.textContent='Moto sélectionnée. Affichez tout ou précisez une famille de pièces.';
      if(!firstReadyShown){firstReadyShown=true;submit.classList.add('is-first-ready');window.setTimeout(function(){submit.classList.remove('is-first-ready');},950);}
    }else{setProgress(34);status.textContent='Choisissez votre modèle.';}
  });

  part.addEventListener('change',function(){
    if(!model.value)return;setProgress(100);var text=part.options[part.selectedIndex].text;
    status.textContent=text==='Toutes les pièces'?'Toutes les références compatibles seront affichées.':text+' : filtre prêt pour votre moto.';
    track('emx_selector_part_type',{brand:brand.value||'',model:model.value||'',part_type:part.value});
  });

  form.addEventListener('submit',function(event){
    event.preventDefault();if(!model.value)return;
    var target='/collections/'+model.value;
    if(part.value&&part.value!=='all')target+='/emx-type-'+encodeURIComponent(part.value);
    track('emx_selector_submit',{brand:brand.value||'',model:model.value,part_type:part.value||'all',target:target});
    setProgress(100);form.classList.add('is-confirmed');submit.disabled=true;
    if(submitLabel)submitLabel.textContent='Ouverture des pièces';status.textContent='Sélection prête.';
    window.setTimeout(function(){window.location.href=target;},reduce?20:260);
  });
})();
